<kendo-drawer-container>
  <kendo-drawer [expanded]="drawerOpen" mode="push" position="start" [mini]="false">
    <ng-template kendoDrawerTemplate>
      <div class="drawer-menu">
        <button kendoButton look="flat" (click)="navigate('smart/formsList')">
           <span style="margin-right: 8px">
            <kendo-icon name="menu"></kendo-icon>
          </span>
          Forms List
        </button>

        <button kendoButton look="flat" (click)="navigate('smart/orgQueue')">
           <span style="margin-right: 8px">
            <kendo-icon name="menu"></kendo-icon>
          </span>
          Org Queue
        </button>
        <button kendoButton look="flat" (click)="logout()">
           <span style="margin-right: 8px">
            <kendo-icon name="logout"></kendo-icon>
          </span>
          Logout
        </button>

      </div>
    </ng-template>
  </kendo-drawer>
  <kendo-drawer-content>
    <router-outlet></router-outlet>
  </kendo-drawer-content>
</kendo-drawer-container>
